import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { CstmPagination } from "../../../components/Common/Common";
import { Link } from "react-router-dom";

// css
import styles from "./Dashboard.module.scss";
import FeatureCard from "./components/FeatureCard";
import AreaChart from "../../../components/Graph/AreaChart";
import PieChart from "../../../components/Graph/PieChart";
import { catchAsync, checkResponse } from "../../../utilities/utilities";
import {
  DASHBOARD_DATA,
  SERVICE_CATEGORY_LIST,
  SERVICE_PROVIDERS_LIST,
  USER_LIST,
} from "../../../services/ApiCalls";
import Loader from "../../../components/Common/Loader";
import TableLayout from "../../../components/TableLayout";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import Toggle from "../../../components/Common/Toggle";
import moment from "moment/moment";
import TableActions from "../../../components/Common/TableActions";
import TopCategories from "./components/Table/TopCategories";
import TopExperts from "./components/Table/TopExperts";

// img

const Dashboard = () => {
  const [dashboardData, setDashBoardData] = useState();
  const [loader, setLoader] = useState(false);

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await DASHBOARD_DATA();
    checkResponse({ res, setData: setDashBoardData, setLoader });
  }, setLoader);

  useEffect(() => {
    getData();
  }, []);

  console.log("dashboardData", dashboardData);
  return (
    <>
      {loader && <Loader />}
      <section className="position-relative py-2">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Dashboard
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <FeatureCard dashboardData={dashboardData} />
            </Col>
            <Col md="6" className="my-2">
              <div className="cardCstm p-3 border h-100 rounded">
                <div className="cardHead m-0 pb-2">
                  <h6 className="m-0 fw-sbold themeClr">
                    Average Revenue Per Appointment Type
                  </h6>
                </div>
                <div className="cardBody">
                  <AreaChart dashboardData={dashboardData} />
                </div>
              </div>
            </Col>
            <Col md="6" className="my-2">
              <div className="cardCstm p-3 border h-100 rounded">
                <div className="cardHead m-0 pb-2">
                  <h6 className="m-0 fw-sbold">Appointment Status</h6>
                </div>
                <div className="cardBody">
                  <PieChart dashboardData={dashboardData} />
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 border h-100 rounded">
                <div className="cardHead m-0 pb-2">
                  <h6 className="m-0 fw-sbold">Top Categories</h6>
                </div>
                <div className="cardBody"></div>
                <TopCategories />
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 border h-100 rounded">
                <div className="cardHead m-0 pb-2">
                  <h6 className="m-0 fw-sbold">Top Therapist</h6>
                </div>
                <div className="cardBody"></div>
                <TopExperts />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
